// extracted by mini-css-extract-plugin
export default {"PostPopover":"_PostPopover--DA9PW","AnnotationToolbar":"_AnnotationToolbar--AlodZ"};